/*
Do stuff when certain scroll points are reached.
Different purpose than `IntersectionObserver`.
*/

export function run({points} = config) {
  window.addEventListener('scroll', (event) => {
    for (const point of points) {
      const {position, className, onAbove, onBelow} = point;
      if (document.documentElement.scrollTop > position) {
        document.body.classList.add(className);
        onBelow?.();
      } else {
        document.body.classList.remove(className);
        onAbove?.();
      }
    }
  });
  window.dispatchEvent(new Event('scroll'));
}
